<script lang="ts">
	import { checkVisibility } from '$lib/actions/checkVisibility';
	import { getYotpoPreview, type YotpoPreview } from '$lib/review/preview';
	import StarRating from '$lib/review/starRating.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { ISbStoryData } from '@storyblok/js';
	import { fly } from 'svelte/transition';

	interface Props {
		content: ISbStoryData<{ text: string }>['content'];
		delay?: number;
	}

	let { content, delay = 500 }: Props = $props();

	let preview = $state<YotpoPreview>();
</script>

<a
	use:editable={content}
	use:checkVisibility={{ threshold: 0 }}
	class="block"
	href="/reviews"
	target="_blank"
	onvisible={async ({ detail }) => {
		if (!detail || preview) return;

		preview = await getYotpoPreview();
	}}
>
	{#if preview}
		<div
			class="flex flex-col items-center gap-y-3 rounded-xl bg-[#FAF9F9] p-3 pt-4 lg:px-5 lg:py-8"
			in:fly={{ y: '100%', delay, duration: 600 }}
		>
			<div class="text-center text-brown-1">
				<div
					class="text-[36px]/[112%] font-semibold tracking-[-.36px] lg:text-[48px]/[110%] lg:tracking-[-.48px]"
				>
					{preview.averageScore}
				</div>
				<div class="text-[12px]/[112%] max-lg:tracking-[-.12px] lg:text-[14px]/[160%]">
					{preview.totalReviews} Reviews
				</div>
			</div>
			<StarRating score={5} starClass="w-5 h-5 lg:w-7 lg:h-7" />
			<p
				class="text-center font-rhymes text-[20px]/[130%] tracking-[-.4px] lg:text-[24px]/[120%] lg:tracking-[-.72px]"
			>
				{content.text}
			</p>
		</div>
	{:else}
		<div class="h-[284px] animate-pulse rounded-2xl bg-[#FAF9F9]"></div>
	{/if}
</a>

<style>
	p {
		text-shadow: 0px 0px 56.093px rgba(13, 13, 5, 0.2);
	}
</style>
